import { render, staticRenderFns } from "./CardProductMovile.vue?vue&type=template&id=470079c6"
import script from "./CardProductMovile.vue?vue&type=script&lang=js"
export * from "./CardProductMovile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports